import { useNewApplicationState } from '../../../../hooks/new-application-state.hook';

export const useNewAppToggle = () => {
  const { data } = useNewApplicationState.query();
  const { mutateAsync: setState, isPending } = useNewApplicationState.mutation();

  return {
    isEnabled: data?.enabled ?? false,
    setEnabled: (enabled: boolean) => setState({ enabled }),
    isPending,
  };
};
